// extracted by mini-css-extract-plugin
export default {"Header":"EBteigpLX+QpHgOqiaYLZQ=="};